"use strict";

exports.__esModule = true;
exports.AnalyticPayload = void 0;
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/*
 * COPYRIGHT 2020-2022 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 */
var AnalyticPayload = exports.AnalyticPayload = /*#__PURE__*/function () {
  function AnalyticPayload(parser, xml) {
    if (parser) {
      this.linearAdBreaks = parser.linearAdBreaks ? parser.linearAdBreaks : [];
      this.nonLinearAdBreaks = parser.nonLinearAdBreaks ? parser.nonLinearAdBreaks : [];
      this.displayAdBreaks = parser.displayAdBreaks ? parser.displayAdBreaks : [];
      var streamData = parser.getStreamData();
      this.processStreamData(streamData);
    }
    this.setHash(xml);
  }

  /*
   * returns the value of displayAdBreaks
   */
  var _proto = AnalyticPayload.prototype;
  _proto.getDisplayAdBreaks = function getDisplayAdBreaks() {
    return this.displayAdBreaks;
  }

  /*
   * returns the value of earlyReturn, -1 if not set, null if not well-formed
   */;
  _proto.getEarlyReturn = function getEarlyReturn() {
    return this.earlyReturn;
  }

  /*
   * returns the value of linearAdBreaks
   */;
  _proto.getLinearAdBreaks = function getLinearAdBreaks() {
    return this.linearAdBreaks;
  }

  /*
   * returns whether the Vmap has a placeholder break
   */;
  _proto.getHasPlaceholder = function getHasPlaceholder() {
    return this.hasPlaceholder;
  }

  /*
   * returns the value of hostNode
   */;
  _proto.getHostNode = function getHostNode() {
    return this.hostNode;
  }

  /*
   * returns the value of hostSuffix
   */;
  _proto.getHostSuffix = function getHostSuffix() {
    return this.hostSuffix;
  }

  /*
   * returns the value of nonLinearAdBreaks
   */;
  _proto.getNonLinearAdBreaks = function getNonLinearAdBreaks() {
    return this.nonLinearAdBreaks;
  }

  /*
   * returns the value of pdtInitial
   */;
  _proto.getPdtInitial = function getPdtInitial() {
    return this.pdtInitial;
  }

  /*
   * returns the value of pdtStart
   */;
  _proto.getPdtStart = function getPdtStart() {
    return this.pdtStart;
  }

  /*
   * returns the value of pdtEnd
   */;
  _proto.getPdtEnd = function getPdtEnd() {
    return this.pdtEnd;
  }

  /*
   * returns the value of sessionIdentifier
   */;
  _proto.getSessionIdentifier = function getSessionIdentifier() {
    return this.sessionIdentifier;
  }

  /*
   * returns the value of streamDuration
   */;
  _proto.getStreamDuration = function getStreamDuration() {
    return this.streamDuration;
  }

  /*
   * returns true if this payload has any ad breaks
   */;
  _proto.hasAdBreaks = function hasAdBreaks() {
    return this.linearAdBreaks.length > 0 || this.nonLinearAdBreaks.length > 0 || this.displayAdBreaks.length > 0;
  }

  /*
   * returns true if the supplied payload is equal to the receiver
   */;
  _proto.isEqualTo = function isEqualTo(payload) {
    return this.hashCode === payload.hashCode;
  };
  _proto.processStreamData = function processStreamData(streamData) {
    this.sessionIdentifier = streamData.getSessionIdentifier();
    this.streamDuration = streamData.getDuration();
    this.hostNode = streamData.getHostNode();
    this.hostSuffix = streamData.getHostSuffix();
    this.pdtInitial = streamData.getPdtInitial();
    this.pdtStart = streamData.getPdtStart();
    this.pdtEnd = streamData.getPdtEnd();
    this.earlyReturn = streamData.getEarlyReturn();
    this.hasPlaceholder = streamData.getHasPlaceholder();
  };
  _proto.setHash = function setHash(xml) {
    if (!xml) {
      return;
    }
    var hash = 0;
    var i;
    var chr;
    for (i = 0; i < xml.length; i++) {
      chr = xml.charCodeAt(i);
      hash = (hash << 5) - hash + chr;
      hash = hash & hash;
    }
    this.hashCode = hash;
  };
  _proto.toString = function toString() {
    var ret = "Linear AdBreaks:";
    for (var _iterator = _createForOfIteratorHelperLoose(this.linearAdBreaks), _step; !(_step = _iterator()).done;) {
      var lab = _step.value;
      ret += "\n" + lab;
    }
    ret += "\n\nNonLinear AdBreaks:";
    for (var _iterator2 = _createForOfIteratorHelperLoose(this.nonLinearAdBreaks), _step2; !(_step2 = _iterator2()).done;) {
      var nla = _step2.value;
      ret += "\n" + nla;
    }
    ret += "\n\nDisplay AdBreaks:";
    for (var _iterator3 = _createForOfIteratorHelperLoose(this.displayAdBreaks), _step3; !(_step3 = _iterator3()).done;) {
      var dab = _step3.value;
      ret += "\n" + dab;
    }
    ret += "\n\nHostNode:";
    ret += "\n" + this.hostNode;
    ret += "\n\nHostSuffix:";
    ret += "\n" + this.hostSuffix;
    ret += "\n\nSessionIdentifier:";
    ret += "\n" + this.sessionIdentifier;
    ret += "\n\nStreamDuration:";
    ret += "\n" + this.streamDuration;
    ret += "\n\npdtInitial:";
    ret += "\n" + this.pdtInitial;
    ret += "\n\npdtStart:";
    ret += "\n" + this.pdtStart;
    ret += "\n\npdtEnd:";
    ret += "\n" + this.pdtEnd;
    ret += "\m\mearlyReturn:";
    ret += "\n" + this.earlyReturn;
    return ret;
  };
  return AnalyticPayload;
}();